export class MotifChange {
  public motif: string;

  constructor() {
  }
}
